// extracted by mini-css-extract-plugin
export default {"root":"styles_root__IjsZv","label":"styles_label__lU8hS"};